import { useEffect, useState } from 'react';
import { Box, Paper, Grid, Chip, Link } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { fingpayCmsListTransactionsApi } from 'utils/API/Merchant APIs/MerchantApiCalls';
import styles from './CmsTransactionList.module.css';
import BreadcrumbComponent from 'views/Components/BreadCrumb';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { checkIsMerchantOrBcGlobal } from 'redux/merchantSlice';
import { useDispatch, useSelector } from 'react-redux';
import BcConvertModal from 'views/Components/BcConvertModal';
const CmsTransactionList = () => {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const dispatch = useDispatch();
    const { agentType, pendingStatus, eSignStatus } = useSelector((state) => state.merchant);
    const merchantModalOpen =
        agentType === 'Merchant' || eSignStatus === false || pendingStatus || localStorage.getItem('merchantToBcStatus') === 'rejected';
    const isBcConvertPending = pendingStatus;
    const getCmsTransactionList = async () => {
        try {
            setLoading(true);
            const formattedFromDate = fromDate ? dayjs(fromDate).format('YYYY/MM/DD') : '';
            const formattedToDate = toDate ? dayjs(toDate).format('YYYY/MM/DD') : '';
            const agentid = localStorage.getItem('id');
            const payload = { agentid, page: page + 1, limit: pageSize, fromdate: formattedFromDate, todate: formattedToDate };
            const response = await fingpayCmsListTransactionsApi(payload);

            if (response?.status === 200) {
                setTransactions(response.data?.data || []);
                setRowCount(response.data?.totalCount || 0);
            } else {
                setTransactions([]);
            }
        } catch (error) {
            console.error('Failed to fetch transactions:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getCmsTransactionList();
        // eslint-disable-next-line
    }, [page, pageSize, fromDate, toDate]);
    useEffect(() => {
        dispatch(checkIsMerchantOrBcGlobal());
    }, [dispatch]);
    const columns = [
        { field: 'slno', headerName: 'Sl. No', width: 80 },
        { field: 'created_at', headerName: 'Date', width: 150, valueFormatter: (params) => dayjs(params.value).format('YYYY/MM/DD HH:mm') },
        { field: 'product', headerName: 'Product', width: 100 },
        { field: 'biller_name', headerName: 'Biller', width: 120 },
        { field: 'fp_transaction_id', headerName: 'FP Txn ID', width: 180 },
        { field: 'merchant_transaction_id', headerName: 'Merchant Txn ID', width: 180 },
        { field: 'biller_transaction_id', headerName: 'Biller Txn ID', width: 180 },
        { field: 'csp_id', headerName: 'CSP ID / Email', width: 200 },
        { field: 'agent_mobileno', headerName: 'Agent Mobile', width: 140 },
        { field: 'amount', headerName: 'Amount', width: 100 },
        {
            field: 'status',
            headerName: 'Status',
            width: 120,
            renderCell: (params) => (
                <Chip
                    label={params.value}
                    color={params.value === 'SUCCESS' ? 'success' : params.value === 'FAILED' ? 'error' : 'warning'}
                    size="small"
                />
            )
        },
        {
            field: 'reciept',
            headerName: 'Receipt',
            width: 100,
            renderCell: (params) =>
                params.value ? (
                    <Link href={params.value} target="_blank" rel="noopener">
                        View
                    </Link>
                ) : (
                    '-'
                )
        }
    ];

    const breadCrumbRoutes = [{ path: '', label: 'CMS Service Transaction List' }];
    return (
        <>
            <Box className={styles.container}>
                <BreadcrumbComponent routes={breadCrumbRoutes} />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Grid container spacing={2} className={styles.dateFilters}>
                        <Grid item xs={12} md={3}>
                            <DatePicker label="From Date" value={fromDate} onChange={(date) => setFromDate(date)} format="YYYY/MM/DD" />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <DatePicker label="To Date" value={toDate} onChange={(date) => setToDate(date)} format="YYYY/MM/DD" />
                        </Grid>
                    </Grid>
                </LocalizationProvider>

                <Paper elevation={3} className={styles.tableWrapper}>
                    <DataGrid
                        rows={transactions}
                        columns={columns}
                        loading={loading}
                        pagination
                        page={page}
                        pageSize={pageSize}
                        rowCount={rowCount}
                        paginationMode="server"
                        onPageChange={(newPage) => setPage(newPage)}
                        onPageSizeChange={(newSize) => {
                            setPageSize(newSize);
                            setPage(0);
                        }}
                        rowsPerPageOptions={[10, 25, 50]}
                        className={styles.table}
                        autoHeight
                    />
                </Paper>
            </Box>
            {merchantModalOpen && (
                <BcConvertModal
                    isOpen={merchantModalOpen}
                    // handleclose={handleBcModalClose}
                    isPending={isBcConvertPending}
                    isESigned={eSignStatus}
                />
            )}
        </>
    );
};

export default CmsTransactionList;
